import React, { Fragment, useState } from 'react';
import Button from '../../../Button';
import Modal from '../../../common/Modal';
import Form from './form';
import { ToastContainer } from 'react-toastify';

const TransferStudentImage = ({ studentImageId }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <Fragment>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Modal
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel="Transfer image to another student"
        headerText="Transfer image to another student"
      >
        <Form closeModal={closeModal} studentImageId={studentImageId} />
      </Modal>

      <Button onClick={openModal}>Transfer image</Button>
    </Fragment>
  )
}

export default TransferStudentImage;
